import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { apiFetch } from "../../pages/marketplace/api";

/**
 * Hot Deals rail for the Marketplace home (Session 36, P3).
 * Surfaces approved vendors running active coupons/deals, with a fast path
 * to their storefront. Renders nothing when no vendor has an active promo.
 */
export function HotDealsRail({ onSelect }) {
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    apiFetch("/marketplace/hot-deals")
      .then((d) => setVendors(d.vendors || []))
      .catch(() => setVendors([]));
  }, []);

  if (!vendors.length) return null;

  return (
    <div className="mp-section" data-testid="hot-deals-rail">
      <div className="mp-section-header">
        <span className="mp-section-title" style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Flame size={15} color="#e85d4a" /> Hot Deals
        </span>
      </div>
      <div className="mp-hotdeals-scroll">
        {vendors.map((v) => (
          <button
            key={v.id}
            type="button"
            className="mp-hotdeal-card"
            onClick={() => onSelect(v)}
            data-testid={`hot-deal-${v.id}`}
          >
            <div className="mp-hotdeal-avatar">
              {v.avatar_url ? (
                <img src={v.avatar_url} alt={v.store_name} />
              ) : (
                (v.store_name || "?")[0]
              )}
            </div>
            <div className="mp-hotdeal-info">
              <p className="mp-hotdeal-name">{v.store_name}</p>
              <div className="mp-hotdeal-chips">
                {(v.deal_chips || []).map((c, i) => (
                  <span key={i} className="mp-hotdeal-chip">{c}</span>
                ))}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
